import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var typography = createRuntimeFn({defaultClassName:'fx_b6b0f3e6_g015cg5',variantClassNames:{ellipsis:{true:'fx_b6b0f3e6_g015cg6',false:'fx_b6b0f3e6_g015cg7'},gradientText:{true:'fx_b6b0f3e6_g015cg8',false:'fx_b6b0f3e6_g015cg9'},inherit:{true:'fx_b6b0f3e6_g015cga',false:'fx_b6b0f3e6_g015cgb'},monospace:{true:'fx_b6b0f3e6_g015cgc',false:'fx_b6b0f3e6_g015cgd'}},defaultVariants:{inherit:false,monospace:false},compoundVariants:[]});
var typographyColor = 'var(--fx_b6b0f3e6_g015cg4)';
var typographyLineClamp = 'var(--fx_b6b0f3e6_g015cg3)';
var typographyLineHeight = 'var(--fx_b6b0f3e6_g015cg2)';
var typographySize = 'var(--fx_b6b0f3e6_g015cg0)';
var typographyWeight = 'var(--fx_b6b0f3e6_g015cg1)';

export { typography, typographyColor, typographyLineClamp, typographyLineHeight, typographySize, typographyWeight };
//# sourceMappingURL=typography.vanilla.mjs.map
